<template>
	<page>
		<div :class="['resp-container', displayView, iframeGameVersionClass]">
			<iframe
				class="resp-iframe"
				ref="iframe"
				:src="src"
				allowfullscreen
				scrolling="no"
			></iframe>
		</div>
	</page>
</template>

<script>
export default {
	name: "game-preview-view",
	props: ["displayView", "index", "single"],
	components: {},
	data() {
		return {
			json: {},
			iframeReady: false,
			overrideSrc: "",
      reload : 1
		};
	},
	computed: {
		game() {
			return this.$store.getters.game;
		},
		canSendJson() {
			return this.game;
		},
		src() {
			let src;
			if(this.game.type && this.game.type.preview_iframe_override != null && this.game.type.preview_iframe_override != 'null') {
				src = this.game.type.preview_iframe_override;
			} else {
				src = `https://pashframe.closeapp.co.il/games/indexEditModeZim2.html?game=true&hide_ani=true&key=${this.index}`;
			}
			if (this.displayView === "mobile") src += "&mobileView=true";
			src += "&previewMode";
      src += `&reload=${this.reload}`
			return src;
		},
		iframeGameVersionClass() {
			if(this.src.includes('/pash/')) {
				return 'v1-game';
			} else {
				return 'v2-game';
			}
		}
	},
	methods: {
		receiveMessage(event) {
			// if (event.origin !== "https://closeapp.co.il")
			// 	return;
			if (event.data.action === "iframeReady") {
				this.iframeReady = true;
				if (this.canSendJson) {
					this.sendJson(event.source);
				}
			}
      else if(event.data.action === "needRefresh") {
        this.reload ++;
      }
		},
		sendJson() {
			window.popup = this.$refs.iframe;
			if (window.popup)
				window.popup.contentWindow.postMessage(
					{
						action: "getJson",
						json: JSON.parse(this.game.json),
						language: this.$i18n.locale
					},
					"*"
				);
		},
		postIframe() {
			let iframe = this.$refs.iframe;
			if (iframe) {
				iframe.onload = () => {
					this.sendJson();
				};
			}
		}
	},
	watch: {
		game: {
			immediate: true,
			handler() {
				if (this.canSendJson) {
					if (this.iframeReady) this.sendJson();
					else this.postIframe();
				}
			}
		}
	},
	created() {
		window.addEventListener("message", this.receiveMessage);
	},
	destroyed() {
		window.removeEventListener("message", this.receiveMessage);
	}
};
</script>

<style scoped>
.resp-iframe {
  border: 0;
  display: block;
  width:100%;
  aspect-ratio: 43 / 27;
  max-height: 70vh;
}

.v2-game .resp-iframe {
	aspect-ratio: 1720/1180;
}

.mobile .resp-iframe {
	aspect-ratio: 15 / 8 !important;
}

main {
  padding: 0 !important;
}

</style>
